import { render } from "./RefundTransactionForm.vue?vue&type=template&id=868a3228"
import script from "./RefundTransactionForm.vue?vue&type=script&lang=js"
export * from "./RefundTransactionForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__